module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-accordion"
  }, [_c('ul', {
    directives: [{
      name: "f-accordion",
      rawName: "v-f-accordion"
    }],
    staticClass: "accordion",
    attrs: {
      "data-accordion": "data-accordion",
      "data-allow-all-closed": _vm.allClosed,
      "data-multi-expand": _vm.multiExpand
    }
  }, _vm._l((_vm.titles), function(title) {
    return _c('li', {
      staticClass: "accordion-item",
      attrs: {
        "data-accordion-item": "data-accordion-item"
      }
    }, [_c('a', {
      staticClass: "accordion-title",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(title))]), _c('div', {
      staticClass: "accordion-content",
      attrs: {
        "data-tab-content": "data-tab-content"
      }
    }, [_vm._t(title)], 2)])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d1d788e6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/foundation/Accordion.vue
// module id = 2691
// module chunks = 1